import { Component, Injector } from "@angular/core";
import { Router } from "@angular/router";
import { AfAuctionModel } from "@pattonair/auction-framework";
import { MfBaseComponent, MfTypeInfo, mfTypeIsUndefined } from "@pattonair/material-framework";
import { AucRouteNames } from "../route.names";
import { AucAuctionService } from "../services/auction.service";

const TYPE_INFO: MfTypeInfo = { className: "AucBidListComponent" };

@Component({
  selector: "ecom-bid-list",
  templateUrl: "./bid.list.component.html",
  styleUrls: ["./bid.list.component.scss"]
})
export class AucBidListComponent extends MfBaseComponent {

  protected _auctions: AfAuctionModel[] = [];

  public constructor(
    protected override _injector: Injector,
    protected _auctionService: AucAuctionService,
    protected _router: Router,
  ) {
    super(TYPE_INFO, _injector);
    this._getLiveAuctions();
  }

  protected _getLiveAuctions(): void {
    const loading = this._subLoading(this._auctionService.getBiddingLive(), {
      next: (auctions) => {
        this._auctions = auctions;
        loading.complete();
      },
      error: () => {
        loading.complete();
      },
    });
  }

  protected _goToDetail(auction: AfAuctionModel): void {
    if (!mfTypeIsUndefined(auction) && !mfTypeIsUndefined(auction.id)) {
      this._router.navigate([AucRouteNames.getBidAuctionDetailRouteAuctionId(auction.id)]);
    }
  }
}